class Faqs {
	constructor(sel) {
		// view
		this.components = document.querySelectorAll(sel);

		if (this.components.length) {
			this.init();
		}
	}

	init() {
		this.components.forEach(comp => {
			this.initQuestions(comp);
			// this.initFilter(comp)
		})
	}
	resetQuestions = (comp) => {
		const questions = comp.querySelectorAll('.category li');
		questions.forEach(faq => {
			faq.classList.toggle('active', false);
		})
	}
	initQuestions(comp) {
		const questions = comp.querySelectorAll('.category li');
		questions.forEach(faq => {
			faq.addEventListener('click', () => {
				this.resetQuestions(comp);
				const isActive = faq.classList.contains('active');
				faq.classList.toggle('active', true);
				if (isActive) return;
			})
		})
	}
}

const example = new Faqs(".faqs");
